import { z } from 'zod';

const RecipientSchema = z.object({
  id: z.string(),
  name: z.string(),
});

// A selected fabricator group: which of its users are checked
const FabricatorRecipientSchema = z.object({
  id: z.string(),
  entity: RecipientSchema,
  allChildrenSelected: z.boolean(),
  children: z.array(RecipientSchema),
});

export const AppNotificationFormSchema = z
  .object({
    id: z.string(),
    action: z.enum(['saveAsDraft', 'publish']),
    concurrencyToken: z.string().nullable(),
    title: z.string(),
    sendNow: z.boolean(),
    scheduledSentDate: z.number().nullable(),
    scheduledSentTime: z.string().nullable(),
    message: z.string(),
    fmiRecipients: z.array(RecipientSchema),
    fabricatorRecipients: z.array(FabricatorRecipientSchema),
    supplierRecipients: z.array(RecipientSchema),
  })
  .superRefine((data, ctx: any) => {
    if (!data.title?.trim()) {
      ctx.addIssue({
        path: ['title'],
        message: 'Title is required',
        code: 'custom',
      });
    } else if (data.title.length > 100) {
      ctx.addIssue({
        path: ['title'],
        message: 'Title must be 100 characters or fewer',
        code: 'custom',
      });
    }

    if (data.message && data.message.length > 100) {
      ctx.addIssue({
        path: ['message'],
        message: 'Message must be 100 characters or fewer',
        code: 'custom',
      });
    }

    if (data.action === 'publish') {
      if (!data.sendNow) {
        if (!data.scheduledSentDate) {
          ctx.addIssue({
            path: ['scheduledSentDate'],
            message: 'Schedule sent date is required',
            code: 'custom',
          });
        }

        if (!data.scheduledSentTime) {
          ctx.addIssue({
            path: ['scheduledSentTime'],
            message: 'Schedule sent time is required',
            code: 'custom',
          });
        }
      }

      if (!data.message?.trim()) {
        ctx.addIssue({
          path: ['message'],
          message: 'Message is required',
          code: 'custom',
        });
      }

      if (
        data.fmiRecipients.length === 0 &&
        data.fabricatorRecipients.length === 0 &&
        data.supplierRecipients.length === 0
      ) {
        ctx.addIssue({
          path: ['supplierRecipients'],
          message: 'At least one recipient is required',
          code: 'custom',
        });
      }
    }
  });
